import useIsDesktop from "@hooks/useIsDesktop"
import useSlugExtractor from "@hooks/useSlugExtractor"

import { AccessCheck } from "@particles"

import { NavTopBar } from "@organisms"
import ViewTypesProvider from "@organisms/ObjectsView/ViewTypesProvider/ViewTypesProvider"

import { AppFrame } from "@templates"

import { INVOICES_ROUTES } from "@routes/invoices"

import { objectMap } from "@constants/objectMap"
import { PERMISSION_LEVEL } from "@constants/permissionLevel"
import { INVOICES_LIST_CONTROLS_VIEW } from "@constants/storage"

import InvoiceCardView from "./views/InvoiceCardView/InvoiceCardView"
import InvoiceTableView from "./views/InvoiceTableView/InvoiceTableView"

export default function InvoiceList() {
    const isDesktop = useIsDesktop()

    const [createRoute] = useSlugExtractor([INVOICES_ROUTES.CREATE])

    return (
        <AppFrame.Root collaborationRoomName="invoice-list">
            <ViewTypesProvider
                viewTypeKey={INVOICES_LIST_CONTROLS_VIEW}
                defaultViewType={isDesktop ? "table" : "card"}
            >
                {({ activeViewType }) => (
                    <>
                        <NavTopBar.Root>
                            <NavTopBar.Header>
                                <NavTopBar.NavTopBarHeaderStart>
                                    <NavTopBar.PageTitle
                                        label={objectMap.invoice.labelPlural}
                                        icon={objectMap.invoice.iconActive}
                                    />
                                </NavTopBar.NavTopBarHeaderStart>
                                <NavTopBar.NavTopBarHeaderEnd>
                                    <NavTopBar.PagePresence />
                                    <AccessCheck
                                        permissions={{
                                            invoices_list_permission: PERMISSION_LEVEL.RESTRICTED,
                                        }}
                                    >
                                        <AccessCheck
                                            permissions={{
                                                invoices_view_permission: PERMISSION_LEVEL.FULL,
                                            }}
                                        >
                                            <NavTopBar.SearchButton scope="Invoices" />
                                        </AccessCheck>
                                    </AccessCheck>
                                    <AccessCheck
                                        permissions={{
                                            invoices_create_permission: PERMISSION_LEVEL.RESTRICTED,
                                        }}
                                    >
                                        <NavTopBar.CTAButton destination={createRoute} />
                                    </AccessCheck>
                                </NavTopBar.NavTopBarHeaderEnd>
                            </NavTopBar.Header>
                        </NavTopBar.Root>
                        {activeViewType === "card" ? <InvoiceCardView /> : <InvoiceTableView />}
                    </>
                )}
            </ViewTypesProvider>
        </AppFrame.Root>
    )
}
